import type { TypoProps } from '@/components/Typography';
import Typo from '@/components/Typography/Typo';
import { cn } from '@/lib/cn';

export const EllipsisValue = (props: TypoProps) => {
  const { children, className, ...rest } = props;
  return (
    <Typo
      ellipsis
      type="label3"
      className={cn('max-w-[120px]', className)}
      {...rest}
    >
      {children}
    </Typo>
  );
};
